//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseImporter.js";
let d=[[[0,"AcadLayoutsToImport",1,0],[0,"AspectRatioOption",1,0],[0,"AvoidUsedNXLayers",1,0],[0,"ConvLayoutData",1,0],[0,"ConvLayouts",1,0],[0,"ConvModelData",1,0],[0,"CrossHatchMappingFile",1,0],[0,"DestForUnselectedLayer",1,0],[0,"DrawingSheetNametoImportModelData",1,0],[0,"FacetImport",1,0],[0,"FileOpenFlag",1,0],[0,"HealBodies",1,0],[0,"ImportBlockType",1,0],[0,"ImportCurvesType",1,0],[0,"ImportDimensionType",1,0],[0,"ImportPolylineTo",1,0],[0,"ImportTo",1,0],[0,"ImportToTeamcenter",1,0],[0,"LineFontMappingFile",1,0],[0,"ModelScaleFactor",1,0],[0,"Optimize",1,0],[0,"ProcessingOrder",1,0],[0,"ReadLayerNumFromPrefix",1,0],[0,"RotationAngle",1,0],[0,"SendLayoutsTo",1,0],[0,"SendModelDataTo",1,0],[0,"SettingsFile",1,0],[0,"SimplifyGeometry",1,0],[0,"SkipEmptyLayer",1,0],[0,"TemplateFile",1,0],[0,"TextFontMappingFile",1,0],[0,"TranslateUnselectedLayer",1,0],[0,"TranslationX",1,0],[0,"TranslationY",1,0],[0,"TranslationZ",1,0],[0,"UnSelectedLayers",1,0],[0,"Units",1,0],[0,"Workflow",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.DxfdwgImporter = class extends SPLM.BaseImporter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DxfdwgImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DxfdwgImporter.ImportToEnum = Object.freeze({
    "Work" : "Work", "New" : "New"});

SPLM.DxfdwgImporter.UnitsEnum = Object.freeze({
    "SameAsTemplate" : "SameAsTemplate", "Metric" : "Metric", "English" : "English", "Micrometer" : "Micrometer", "Meter" : "Meter"});

SPLM.DxfdwgImporter.ImportPolylinesAs = Object.freeze({
    "Splines" : "Splines", "ArcLines" : "ArcLines"});

SPLM.DxfdwgImporter.SendModelDataAs = Object.freeze({
    "Modeling" : "Modeling", "DrawingView" : "DrawingView", "DrawingSheet" : "DrawingSheet", "NewDrawingSheet" : "NewDrawingSheet", "SelectedDrawingSheet" : "SelectedDrawingSheet"});

SPLM.DxfdwgImporter.SendLayoutsAs = Object.freeze({
    "ImportedView" : "ImportedView", "DrawingView" : "DrawingView"});

SPLM.DxfdwgImporter.ConvLayoutsAs = Object.freeze({
    "All" : "All", "SelectedInPreview" : "SelectedInPreview"});

SPLM.DxfdwgImporter.ImportCurvesAs = Object.freeze({
    "SketchCurves" : "SketchCurves", "Curves" : "Curves"});

SPLM.DxfdwgImporter.ImportDimensionsAs = Object.freeze({
    "Real" : "Real", "Group" : "Group"});

SPLM.DxfdwgImporter.ImportBlocksAs = Object.freeze({
    "Group" : "Group", "CustomSymbol" : "CustomSymbol", "Part" : "Part", "NX2DComponent" : "NX2DComponent", "DisplayInstance" : "DisplayInstance"});

SPLM.DxfdwgImporter.ProcessingOrderAs = Object.freeze({
    "Alphabetical" : "Alphabetical", "ObjectCount" : "ObjectCount"});

SPLM.DxfdwgImporter.AspectRatioOptions = Object.freeze({
    "AutomaticCalculation" : "AutomaticCalculation", "UseSameAsACADWidthFactor" : "UseSameAsACADWidthFactor", "UseValueSpecifiedInMappingFile" : "UseValueSpecifiedInMappingFile", "ScaleACADWidthFactorWithSpecifiedValue" : "ScaleACADWidthFactorWithSpecifiedValue"});

SPLM.DxfdwgImporter.WorkflowAs = Object.freeze({
    "Drawing" : "Drawing", "ThreeD" : "ThreeD"});

SPLM.DxfdwgImporter.FacetImportAs = Object.freeze({
    "Jt" : "Jt", "Convergent" : "Convergent"});

export default SPLM;